import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, inject } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PreviousRouteService } from '@src/core/services';
import { ViewMode } from '@src/models';

@Component({
  selector: 'lp-collection-info-header',
  templateUrl: './collection-info-header.component.html',
  styleUrls: ['./collection-info-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionInfoHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
  @Input() mode?: ViewMode;
  @Input() allowCollectionStatisticsViewing = false;
  @Input() id?: string;
  @Input() unionId?: string;

  @Output() cancelEdit = new EventEmitter<void>();

  private readonly previousRouteService = inject(PreviousRouteService);

  onClickBackButton() {
    if (this.mode === 'edit' || this.mode === 'create') {
      this.cancelEdit.emit();
      return;
    }

    this.previousRouteService.back('/loyalty');
  }
}
